import { render, staticRenderFns } from "./MeetingsListModal.vue?vue&type=template&id=8c0d83d2&scoped=true&"
import script from "./MeetingsListModal.vue?vue&type=script&lang=js&"
export * from "./MeetingsListModal.vue?vue&type=script&lang=js&"
import style0 from "./MeetingsListModal.vue?vue&type=style&index=0&id=8c0d83d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0d83d2",
  null
  
)

export default component.exports